import { Dispatch, SetStateAction, useEffect } from "react";
import { useFormikContext } from "formik";
import { Abfallart } from "../../api";
import {
  ExtendedAbladestelleDaten,
  Material,
} from "../../pages/abladestellen/AbladestellenDetails";

interface FormDatenDirtyCheckerProps {
  setIsFormDatenDirty: Dispatch<SetStateAction<boolean>>;
}

export default function AbladestellenFormDatenDirtyChecker({
  setIsFormDatenDirty,
}: FormDatenDirtyCheckerProps) {
  const { dirty, values, initialValues } =
    useFormikContext<ExtendedAbladestelleDaten>();

  useEffect(() => {
    const dirtyFields: string[] = [];

    (
      [
        "kurzname",
        "firma",
        "ort",
        "isDeponie",
      ] as (keyof ExtendedAbladestelleDaten)[]
    ).forEach((key: keyof ExtendedAbladestelleDaten) => {
      if (values[key] !== initialValues[key]) {
        dirtyFields.push(key as string);
      }
    });

    values.materials.forEach((mat: Material, index: number) => {
      const initialMat: Material = initialValues.materials[index];
      if (!initialMat) {
        dirtyFields.push(`materials[${index}] (new entry)`);
        return;
      }

      (Object.keys(mat) as (keyof Material)[]).forEach(
        (fieldKey: keyof Material) => {
          if (mat[fieldKey] !== initialMat[fieldKey]) {
            if (fieldKey === "abfallart") {
              const abfallart = mat[fieldKey] as Abfallart;
              if (abfallart) {
                if (abfallart.id !== initialMat[fieldKey]) {
                  dirtyFields.push(`materials[${index}].${fieldKey}`);
                }
              }
            } else {
              dirtyFields.push(`materials[${index}].${fieldKey}`);
            }
          }
        }
      );
    });

    const isDirty = dirtyFields.length > 0;
    setIsFormDatenDirty(isDirty);
  }, [dirty, initialValues, setIsFormDatenDirty, values]);

  return null;
}
